module.exports = __webpack_public_path__ + "img/BRCA1_CD4Tconv.f71ee3ea.png";